"use client";

import styled from "styled-components";

export const ParagraphSectionWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
  margin-bottom: 4.8rem;

  .article-detail-mobile-ui-true & {
    gap: 0.4rem;
    margin-bottom: 1.2rem;
  }

  @media only screen and (max-width: 768px) {
    gap: 0.4rem;
    margin-bottom: 1.2rem;
  }
`;
